import React from 'react';
import { ScrollView, View } from 'react-native';

import PropTypes from 'prop-types';

import { VFScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import PermissionsDescriptionSection from '../../../CommonUI/PermissionsDescriptionSection/PermissionsDescriptionSection';
import { ContactPreferencesCards, ConfirmButton, SuccessModal } from '../../Components';

import styles from './ContactPreferences.Styles';

const ContactPreferences = ({
  onBack,
  onClose,
  theme,
  section,
  contactPrefData,
  images,
  isButtonDisabled,
  onButtonPress,
  successModalProps,
}) => {
  return (
    <VFScreen
      title="contact_preferences_title"
      showBack
      onBack={onBack}
      onClose={onClose}
      withHeaderSpace
    >
      <View style={styles.container}>
        <ScrollView contentContainerStyle={styles.scrollView}>
          <VFText i18nKey="contact_preferences_title" style={styles.title} type="primary" />
          <PermissionsDescriptionSection
            section={section}
            textColor={theme.colors.text.primaryGrey}
          />
          <ContactPreferencesCards contactPrefData={contactPrefData} images={images} />
        </ScrollView>

        <ConfirmButton isConfirmDisabled={isButtonDisabled} onConfirm={onButtonPress} />
      </View>

      <SuccessModal {...successModalProps} />
    </VFScreen>
  );
};

ContactPreferences.defaultProps = {
  onBack: () => {},
  contactPrefData: [],
  theme: LightThemeColors,
};

ContactPreferences.propTypes = {
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  theme: PropTypes.object,
  section: PropTypes.object.isRequired,
  contactPrefData: PropTypes.array,
  images: PropTypes.object,
  isButtonDisabled: PropTypes.bool,
  onButtonPress: PropTypes.func.isRequired,
  successModalProps: PropTypes.shape({
    isVisible: PropTypes.bool,
    onPrimaryPress: PropTypes.func,
    onSecondaryPress: PropTypes.func,
  }).isRequired,
};
export default withTheme(ContactPreferences);
